import React from "react";
import HomeCard from "./HomeCard";

interface HomeCardsSectionProps {
  cardsConfig?: CardsConfigEntry[];
}

export interface CardsConfigEntry {
  title: string;
  text: string;
  ctaPath: string;
  ctaText: string;
  image: string;
}

const HomeCardsSection = ({ cardsConfig }: HomeCardsSectionProps) => {
  if (!cardsConfig) return;

  return (
    <section className="py-10 px-4">
      <div className="max-w-6xl mx-auto flex flex-wrap justify-center gap-6 [&>*]:w-full [&>*]:sm:w-[calc(50%-0.75rem)]">
        {cardsConfig.map((entry, idx) => (
          <HomeCard
            key={idx}
            title={entry.title}
            text={entry.text}
            ctaPath={entry.ctaPath}
            ctaText={entry.ctaText}
            image={entry.image}
          />
        ))}
      </div>
    </section>
  );
};

HomeCardsSection.propTypes = {};

export default HomeCardsSection;
